






























































import { Component, Vue } from 'vue-property-decorator';
import StateCasesTable from '@/components/StateCasesTable.vue';
import DisplayControls from '@/components/DisplayControls.vue';
import MapSelector from '@/components/MapSelector.vue';
import TwoRowStateSelector from '@/components/TwoRowStateSelector.vue';
import Objective from '@/components/Objective.vue';
// import states from '../states';

import { BIconCaretRightFill, BIconCaretLeftFill } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

import { mapState } from 'vuex'

// interface states {
//   fips: string,
//   abbrev: string,
//   stateName: string,
//   jurisdiction: string
//  }

@Component({
  computed: {
        ...mapState(['selectedMap', 'selectedMapClass', 'selectedStateAbbrev', 'selectedStateName','displayOutput','stateCasesAverted','stateDeathsAverted','stateDataArray'])
    },
  components: {
      BIconCaretRightFill, 
      BIconCaretLeftFill,
      TwoRowStateSelector,
      DisplayControls,
      MapSelector,
      Objective,
      StateCasesTable
  },
  created() {
    this.$store.dispatch("setRoute", "state");

    // if (this.$route.path === '/state') {
    //   this.$router.push('/state/' + this.$store.state.selectedStateAbbrev);
    // }
   
    if (this.$route.params.abbrev) {
    const abbrev = this.$route.params.abbrev;
    this.$store.dispatch("searchByAbbrev", abbrev);
    this.$store.dispatch("selectStateAbbrev", abbrev);
    
    }
  },
  mounted() {
    this.$store.dispatch('drawState');
    this.$store.dispatch("setHref", this.$router.currentRoute.path);
  }
})
export default class State extends Vue {}
